exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sm-label[data-v-1b29c5da]{font-size:12px;line-height:13px;font-weight:700;border-bottom:1px solid #ccc;padding-bottom:5px}", ""]);

// exports
